<template>
  <div id="" class="" pageName="">
    <div class="prism-player" :id="keyword"></div>
  </div>
</template>

<script>
/** */
export default {
  name: "VideoPlay",
  props: ['videoData', "keyword"],
  data() {
    return {};
  },
  mounted() {
    console.log("ASdasdasd", this.videoData);
    this.getAuth();
  },
  methods: {
        // 获取播放凭证
    getAuth() {
      // this.authResult.videoId
      this.$api.get("/content/video/play/auth.json", {
          videoId: this.videoData.videoId,
        }).then((success) => {
            // 打开视频容器
            this.videoFlag = true;
            // 获取成功  播放视频  id 封面  凭证
            this.play(
              success.data.videoMeta.videoId,
              success.data.playAuth,
              success.data.videoMeta.coverURL
            );
          },
          (error) => {
            this.$message.error(error.msg);
          }
        ).catch((error) => {
          console.log(error);
          this.$message.error("播放凭证获取异常！");
        });
    },
    play(vid, playauth, cover) {
      // console.log(vid);
      // console.log(playauth);
      let player = new Aliplayer(
        {
          id: this.keyword,
          width: "100%",
          autoplay: false, // 自动播放

          //播放方式二：点播用户推荐
          vid: vid,
          playauth: playauth,
          cover: cover,
          // encryptType:1, //当播放私有加密流时需要设置。
        },
        function (player) {
          console.log("播放器创建好了。");
        }
      );
    },
  },
};
</script>

<style scoped>
.prism-player {
  height: 10rem;
}
</style>



// WEBPACK FOOTER //
// src/components/practiceManage/VideoPlay.vue